import { render, staticRenderFns } from "./GradeNewProductForm.vue?vue&type=template&id=4407f87c"
import script from "./GradeNewProductForm.vue?vue&type=script&lang=js"
export * from "./GradeNewProductForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports